// extracted by mini-css-extract-plugin
export default {"priorityHighIcon":"styles__priorityHighIcon__eaa03e2b76d29eeb935d"};